import { ResizeSimpleAction } from "./ResizeSimpleAction.js";
/**
 * @description Defines a limit fitting resize action.
 * @extends Actions.Resize.ResizeSimpleAction
 * @memberOf Actions.Resize
 * @see Visit {@link Actions.Resize| Resize} for examples
 */
class ResizeLimitFitAction extends ResizeSimpleAction {
}
export { ResizeLimitFitAction };
